export default {
  plural_label: "Utilisateurs",
  single_label: "Utilisateur",
  store_namespace: 'user',
  auth_feature: 'user',
  list_route_name: "AdminUserList",
  new_route_name: "AdminUserNew",
  edit_route_name: "AdminUserEdit",
  detail_route_name: "AdminUserDetail",
  use_new_modal: false,
  hide_action_new_button: false,
  use_edit_modal: false,
  csv_export_filename_prefix: 'utilisateurs',
  hide_action_pdf_button: true,
  title_field: 'firstname',
  sort_by: 'firstname',
  valide_form_function: function (form) {
    if ((!form.id || form.reset_password === true) && (!form.password || !form.confirm_password || form.password !== form.confirm_password)) {
      return "Le mot de passe saisi et sa confirmation doivent être strictement identiques"
    }
    return true
  },
  fields: [{
      name: 'firstname',
      label: "Prénom",
      type: 'text',
      inForm: true,
      required: true,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
    },
    {
      name: 'lastname',
      label: "Nom",
      type: 'text',
      inForm: true,
      required: true,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
    },
    {
      name: 'email',
      label: "Email",
      type: 'email',
      inForm: true,
      required: true,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: true,
      link: (context, value) => value ? 'mailto:' + value : null,
      inCsvExport: true,
      inPdfExport: true,
      isHtml: true,
      formatter: (context, value) => value ? value : null
    },
    {
      name: 'role',
      label: "Rôle",
      type: 'select',
      inForm: true,
      required: true,
    },
    {
      name: 'roles',
      label: "Rôle",
      type: 'select',
      inList: true,
      sortable: true,
      filterIn: false,
      extended_filter: true,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
      formatter: (context, value) => value && value[0] ? context.$store.getters['user/getRole'](value[0]) ? context.$store.getters['user/getRole'](value[0]).text : null : null
    },
    {
      name: 'agency_id',
      label: "Agence",
      type: 'chosen',
      inForm: true,
      required: true,
      inList: false,
      inDetail: false,
      inCsvExport: false,
      inPdfExport: false,
    },
    {
      name: 'agency',
      label: "Agence",
      type: 'select',
      sortable: true,
      inForm: false,
      inList: true,
      filterIn: true,
      extended_filter: false,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
      formatter: (context, value) => value ? value.name : null
    },
    {
      name: 'vehicle_id',
      label: "Véhicule",
      type: 'chosen',
      inForm: true,
      required: true,
      inList: false,
      inDetail: false,
      inCsvExport: false,
      inPdfExport: false,
    },
    {
      name: 'group_id',
      label: "Groupe",
      type: 'select',
      inForm: true,
      required: true,
      inList: false,
      inDetail: false,
      inCsvExport: false,
      inPdfExport: false,
      disabled: false
    },
    // {
    //   name: 'vehicle',
    //   label: "Véhicule",
    //   type: 'select',
    //   sortable: true,
    //   inForm: false,
    //   inList: true,
    //   filterIn: true,
    //   extended_filter: false,
    //   inDetail: true,
    //   inCsvExport: true,
    //   inPdfExport: true,
    //   formatter: (context, value) => value ? value.name : null
    // },
    // {
    //   name: 'default_imputation_id',
    //   label: "Imputation",
    //   type: 'select',
    //   inForm: true,
    //   required: true,
    //   inList: false,
    //   inDetail: false,
    //   inCsvExport: false,
    //   inPdfExport: false,
    // },
    // {
    //   name: 'auto_restocking',
    //   label: "Auto restocking",
    //   type: 'yesno',
    //   inForm: true,
    //   required: false,
    //   inList: false,
    //   inDetail: false,
    //   inCsvExport: false,
    //   inPdfExport: false,
    // },
    {
      name: 'min_max_stock_management',
      label: "Gestion des stocks min et max",
      type: 'yesno',
      inForm: true,
      required: false,
      inList: false,
      inDetail: false,
      inCsvExport: false,
      inPdfExport: false,
    },
    // {
    //   name: 'stock_adjustment',
    //   label: "Ajustement du stock",
    //   type: 'yesno',
    //   inForm: true,
    //   required: false,
    //   inList: false,
    //   inDetail: false,
    //   inCsvExport: false,
    //   inPdfExport: false,
    // },
    // {
    //   name: 'imputation',
    //   label: "Imputation",
    //   type: 'select',
    //   sortable: true,
    //   inForm: false,
    //   inList: true,
    //   filterIn: true,
    //   extended_filter: false,
    //   inDetail: true,
    //   inCsvExport: true,
    //   inPdfExport: true,
    //   formatter: (context, value) => value ? value.name : null
    // },
    {
      name: 'reset_password',
      label: "Rédéfinir le mot de passe",
      type: 'yesno',
      inForm: true,
      inFormCondition: (form) => form.id,
    },
    {
      name: 'password',
      label: "Mot de passe",
      type: 'password',
      inForm: true,
      required: true,
      inFormCondition: (form) => !form.id || form.reset_password === true,
    },
    {
      name: 'confirm_password',
      label: "Confirmer le mot de passe",
      type: 'password',
      inForm: true,
      required: true,
      inFormCondition: (form) => !form.id || form.reset_password === true,
    },
    {
      name: 'created_at',
      label: "Création",
      type: 'date',
      inForm: false,
      inList: false,
      inDetail: false,
      inCsvExport: true,
      inPdfExport: false,
      formatter: (context, value) => value ? context.$moment(value).format("dddd, DD MMMM YYYY à H:mm") : null
    },
    {
      name: 'updated_at',
      label: "Dernière modification",
      type: 'date',
      inForm: false,
      inList: false,
      inDetail: false,
      inCsvExport: true,
      inPdfExport: false,
      formatter: (context, value) => value ? context.$moment(value).format("dddd, DD MMMM YYYY à H:mm") : null
    },
  ]
}



// WEBPACK FOOTER //
// ./src/components/User/config.js